module.exports = __webpack_public_path__ + "static/img/software_copyright.0218092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/software_copyright.png
// module id = t2bo
// module chunks = 1